import { render, staticRenderFns } from "./PosSales.vue?vue&type=template&id=358c6a43&scoped=true"
import script from "./PosSales.vue?vue&type=script&lang=js"
export * from "./PosSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358c6a43",
  null
  
)

export default component.exports